import React from 'react';

import LabelField from '../../../components/plain/LabelField';
import FieldString from '../../../components/plain/FieldString';
import FieldEnum from '../../../components/plain/FieldEnum';
import FieldList_Strings from '../../../components/plain/FieldList_Strings';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';
import DivLocationList from './DivLocationList';

class TabAAEvents extends React.Component {

	constructor(props) {
		super(props);
	}

	eventCardBuilder = (fieldEvent, index) => {
		let card = '';
		if( fieldEvent.value.name.value )
			card += fieldEvent.value.name.value;
		return card;
	}
	buildEventPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<EventPanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain} readOnly={readOnly} 
			/>
		);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '10px' }}>
				<FieldList_CardsPanel path={'/events'} instance={instance} parentField={parentField} plain={plain} 
					buildItemComponent={this.buildEventPanel} itemCardBuilder={this.eventCardBuilder} 
					labelEmptyToHeader={true} ignoreTitle={true} readOnly={readOnly}
					styles={{
						divMain: {
							padding: '10px 10px 10px 10px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue',
							marginTop: '10px',
							marginBottom: '10px'
						},
						divCardsBlock: {
							backgroundColor: 'rgb(200,200,200)',
							minWidth: '300px'
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
						}
					}}
				/>
			</div>
		);
	}
}

class EventPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
		readOnly
	*/
	constructor(props) {
		super(props);
	}

	descriptionCardBuilder = (fieldDescription, index) => {
		let card = '';
		if( fieldDescription.value.content.value )
			card += fieldDescription.value.content.value;
		if( card.length > 50 )
			card = card.substring(0,47) + '...';
		return card;
	}
	buildDescriptionPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<DescriptionPanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain} readOnly={readOnly} 
			/>
		);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.fieldGroup;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'dates'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}}
						 />
						<FieldEnum instance={instance} path={'type'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {maxWidth: '200px'}}}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'name'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
					<FieldList_CardsPanel path={'descrList'} instance={instance} parentField={parentField} plain={plain} 
						buildItemComponent={this.buildDescriptionPanel} itemCardBuilder={this.descriptionCardBuilder} 
						labelEmptyToHeader={true} ignoreTitle={false} readOnly={readOnly}
						styles={{
							divMain: {
								padding: '10px 10px 10px 10px',
								backgroundColor: 'rgb(200,200,200)',
								border: '1px solid blue',
								marginTop: '10px',
								marginBottom: '10px'
							},
							divCardsBlock: {
								backgroundColor: 'rgb(200,200,200)',
								minWidth: '200px'
							},
							divCard: {
								marginTop: '3px',
								padding: '7px',
								cursor: 'pointer',
								backgroundColor: 'rgb(230,230,230)',
								minHeight: '18px'
							}
						}}
					/>
					<div style={{marginBottom: '15px'}}>
						<DivLocationList  path={'locations'} instance={instance} plain={plain} parentField={parentField} readOnly={readOnly}/>
					</div>
				</div>
			</div>
		)
	}
}

class DescriptionPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.fieldGroup;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'language'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', width: '200px', marginRight: '20px'}}}
						/>
						<FieldEnum instance={instance} path={'format'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1'}}}
						/>
					</div>
					<div style={{marginBottom: '15px'}}>
						<LabelField instance={instance} path={'content'} parentField={parentField} />
						<FieldString  instance={instance} path={'content'} parentField={parentField} plain={plain} 
							readOnly={readOnly}
							multiline={true} rows={4} cols={60}
							styleInput={{width: '98%'}} ignoreTitle={true}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldList_Strings instance={instance} path={'uri'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ divMain: {flexGrow: '1'}}}
						 />
					</div>
				</div>
			</div>
		)
	}
}

export default TabAAEvents;